import clsx from 'clsx'
import React from 'react'

import styles from './panel.module.css'

type Props = {
  open?: boolean
  withMargin?: boolean
  withPadding?: boolean
  fullHeight?: boolean
  children: JSX.Element
}

const Panel = ({ open, children, withMargin, fullHeight, withPadding }: Props) => {
  return (
    <div
      className={clsx(
        styles.panel,
        { [styles.open]: open },
        { [styles.withMargin]: withMargin },
        { [styles.withPadding]: withPadding },
        { [styles.fullHeight]: fullHeight }
      )}
    >
      {children}
    </div>
  )
}

export default Panel
